module.exports = __webpack_public_path__ + "static/img/ppt.86556c5f.png";